module.exports = {"230502001":"二马路街道","230502002":"八马路街道","230502003":"中心站街道","230502004":"富安街道","230502005":"窑地街道","230502006":"长安街道","230502007":"铁西街道","230502200":"安邦乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/230502.json
// module id = 666
// module chunks = 0